import React, { useMemo, useState } from "react";

import CalendarDay from "./CalendarDay";
import CalendarDetails from "./CalendarDetails";
import { getMonthDays, buildDailySummary, formatDate } from "./calendarUtils";

export default function ScorePlusCalendar({ records = [] }) {
  const today = new Date();

  const [month, setMonth] = useState(today.getMonth());

  const [year, setYear] = useState(today.getFullYear());
  const [selectedDay, setSelectedDay] = useState(null);
  const days = useMemo(() => {
    return getMonthDays(year, month);
  }, [year, month]);

  const summary = useMemo(() => {
    return buildDailySummary(records);
  }, [records]);

  const previousMonth = () => {
    if (month === 0) {
      setMonth(11);
      setYear(year - 1);
    } else {
      setMonth(month - 1);
    }
  };

  const nextMonth = () => {
    if (month === 11) {
      setMonth(0);
      setYear(year + 1);
    } else {
      setMonth(month + 1);
    }
  };

  return (
    <div className="bg-gray-900 border border-gray-700 rounded-xl p-5">
      <div className="flex justify-between items-center mb-5">
        <button
          onClick={previousMonth}
          className="w-fit px-3 py-1 bg-gray-800 rounded"
        >
          ◀
        </button>

        <h2 className="text-xl font-bold text-white">
          {new Date(year, month).toLocaleString("default", {
            month: "long",
            year: "numeric",
          })}
        </h2>

        <button onClick={nextMonth} className="w-fit px-3 py-1 bg-gray-800 rounded">
          ▶
        </button>
      </div>

      <div className="grid grid-cols-7 gap-3">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div key={day} className="text-center text-xs text-gray-400">
            {day}
          </div>
        ))}

        {days.map((date, index) => (
          <CalendarDay
            key={index}
            date={date}
            data={summary[formatDate(date)]}
            onClick={(day) => setSelectedDay(day)}
          />
        ))}
      </div>
      {selectedDay && (
        <CalendarDetails
          date={selectedDay}
          data={summary[formatDate(selectedDay)]}
          onClose={() => setSelectedDay(null)}
        />
      )}
    </div>
  );
}
